/**
 * ReportStreamTemplate entity class
 */

/**
 * ReportStreamTemplateFactory
 * returns ReportStreamTemplate entity class
 *
 * @class ReportStreamTemplateFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportStreamTemplate} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportStreamTemplateFactory
 */
/* @ngInject */
export default function ReportStreamTemplateFactory (ReportTemplate, onOffMixin) {
  /* === ReportStreamTemplate class === */

  /**
   * ReportStreamTemplate model
   *
   * @class ReportStreamTemplate
   * @classdesc ReportStreamTemplate model
   * @memberof models
   * @see models
   * @extends models.ReportTemplate
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportStreamTemplate entity fields
   * @return {models.ReportStreamTemplate} ReportStreamTemplate entity
   */
  function ReportStreamTemplate () {
    var obj = ReportTemplate.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportStreamTemplate.prototype = Object.create(ReportTemplate.prototype)
  ReportStreamTemplate.prototype.constructor = ReportStreamTemplate

  /* === User instance methods & fields === */

  Object.assign(ReportStreamTemplate.prototype, {

    /**
     * url template
     *
     * @memberof models.ReportStreamTemplate#
     * @type {String}
     */
    _urlTemplate: 'api/reporttemplates/streams/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ReportStreamTemplate#
     * @type {String}
     */
    _publicUrlTemplate: 'reporttemplates/streams/{{::id}}'

  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from ReportTemplate class
  Object.assign(ReportStreamTemplate, ReportTemplate)
  ReportStreamTemplate._name = 'ReportStreamTemplate'
  ReportStreamTemplate.init()

  // permissions
  // ReportStreamTemplate.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportStreamTemplate
}
